import React, { useEffect, useState } from "react";
import axios from "axios";

export default function VerifyEmail() {
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  const API = process.env.REACT_APP_API_URL || "http://localhost:5002";

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const token = params.get("token");
    const email = params.get("email");
    const type = (params.get("type") || "client").toLowerCase(); // ✅ ICI
    const path = type === "driver" ? "chauffeurs" : "clients";   // ✅ ICI

    if (!token || !email) {
      setStatus("error");
      setMessage("Lien invalide.");
      return;
    }

    (async () => {
      try {
        await axios.get(`${API}/api/${path}/verify-email`, {
          params: { token, email },
        });
        setStatus("ok");
        setMessage("✅ Email confirmé ! Merci 🙌");
      } catch (e) {
        setStatus("error");
        setMessage(e?.response?.data?.message || "Lien expiré ou invalide.");
      }
    })();
  }, [API]);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 20, background: "#0b0f14", color: "white" }}>
      <div style={{ maxWidth: 520, width: "100%", padding: 20, borderRadius: 16, border: "1px solid rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.06)" }}>
        <h2 style={{ margin: 0, marginBottom: 10 }}>
          {status === "loading" ? "Vérification..." : status === "ok" ? "Email confirmé" : "Erreur"}
        </h2>
        <p style={{ opacity: 0.9, margin: 0 }}>{message}</p>

        {status === "ok" && (
          <a href="/" style={{ display: "inline-block", marginTop: 16, padding: "10px 14px", borderRadius: 12, background: "white", color: "#0b0f14", fontWeight: 900, textDecoration: "none" }}>
            Retour au site
          </a>
        )}
      </div>
    </div>
  );
}